<template>
  <b-container class="my-4">
    <b-modal
        no-close-on-backdrop
        @close="goHome()"
        centered
        hide-footer
        ref="confirmation"
        :title="$t('remove-candidate-alert')"
    >
      <div class="text-right">
        <b-button
            variant="primary"
            class="mr-4"
            @click="removeCandidate"
        >
          {{ $t('yes') }}
        </b-button>
        <b-button
            variant="primary"
            @click="goHome()"
        >
          {{ $t('nagora-no-btn') }}
        </b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
  import recruitmentService from "@/services/jobOffer";
  import Utils from "@/mixins/Utils";
  import { ASSIGNED_STATUS, IN_PROGRESS_STATUS } from "../../constants/inscription";

  export default {
    mixins: [Utils],
    computed: {
      uid() {
        return this.$route.query.uid || null;
      }
    },
    created() {
      this.getCandidate();
    },
    methods: {
      getCandidate() {
        recruitmentService.getCandidateByUid(this.uid).then(res => {
          if (!res.success) {
            this.$bvModal.msgBoxOk(this.$t('remove-candidate-not-exist-alert'), {
              centered: true
            })
              .then(() => {
                this.goHome();
              })
          } else {
            if (res.data.idStatus === IN_PROGRESS_STATUS || res.data.idStatus === ASSIGNED_STATUS) {
              this.openPopup();
            } else {
              this.$bvModal.msgBoxOk(this.$t('remove-candidate-invalid-status-alert'), {
                centered: true
              })
                .then(() => {
                  this.goHome();
              })
            }
          }
        });
      },
      openPopup() {
        if (!this.uid) {
          this.goHome();
        }
        this.$refs['confirmation'].show();
      },
      removeCandidate() {
        recruitmentService.removeCandidate(this.uid).then(res => {
          if (res.success) {
            this.$bvModal.msgBoxOk(
              this.$t('remove-candidate-success'), {
                size: 'sm',
                centered: true
              }).then(() => {
              this.goHome();
            });
          } else {
            this.callToaster(this.$t('remove-candidate-fail'));
          }
        }).catch(err => {
          this.callToaster(err.message);
        })
      },
      goHome() {
        this.$router.push({ path: "/public/default" });
      }
    }
  }
</script>

<style scoped>

</style>